import { render, staticRenderFns } from "./ShowValues.vue?vue&type=template&id=2b3b0238&scoped=true"
import script from "./ShowValues.vue?vue&type=script&lang=js"
export * from "./ShowValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b0238",
  null
  
)

export default component.exports